export default __webpack_public_path__ + "static/media/articNav.9027604f.svg";